import { render } from "./icon.vue?vue&type=template&id=1bb4e94a&ts=true"
import script from "./icon.vue?vue&type=script&lang=ts"
export * from "./icon.vue?vue&type=script&lang=ts"

import exportComponent from "/srv/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__